/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import Collection from './collection'
import ReferralCode from './referral_code'
import _ from 'underscore'
import Backbone from '@polleverywhere/backbone'
import URI from 'urijs'

/*
 * A collection of the current users referral codes
 * @namespace Model
 */
class ReferralCodes extends Collection {
  static initClass () {
    this.prototype.model = ReferralCode
  }

  url () {
    return '/api/referral_codes'
  }

  bulkCreateUrl () {
    return URI(this.url()).segment('bulk_create').toString()
  }

  // Referral code that is distributed arbitrarily
  personalCode () {
    return this.find(code => !code.has('recipient'))
  }

  /*
   * Referrals codes that are intended for specific
   * recipients via email
   */
  recipientCodes () {
    return this.filter(code => code.has('recipient'))
  }

  /*
   * Create multiple referral codes
   *
   * options:
   *   emails:   array of email addresses
   *   message:  personal message to send with each email
   */
  bulkCreate (emails, message) {
    if (emails == null) { emails = [] }
    if (message == null) { message = '' }
    return Backbone.ajax({
      url: this.bulkCreateUrl(),
      method: 'post',
      data: {
        emails,
        message
      }
    }).done(data => {
      _.each(data.successes, code => this.add(code))

      if (!_.isEmpty(data.errors)) {
        return this.trigger('bulk_create:errors', data.errors)
      }
    })
  }
}
ReferralCodes.initClass()

export default ReferralCodes
